export const INFORMATION_LIST_FETCH = 'INFORMATION_LIST_FETCH';
export const INFORMATION_LIST_SUCCESS = 'INFORMATION_LIST_SUCCESS';
export const INFORMATION_LIST_FAILURE = 'INFORMATION_LIST_FAILURE';

export const DELETE_INFORMATION_FETCH = 'DELETE_INFORMATION_FETCH';
export const DELETE_INFORMATION_SUCCESS = 'DELETE_INFORMATION_SUCCESS';
export const DELETE_INFORMATION_FAILURE = 'DELETE_INFORMATION_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/InformationList/actionTypes.js